// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"218":"f7a969ee","454":"4141e442","584":"035e5772","787":"cc769e2d","795":"89f2d948"}[chunkId] + ".chunk.js";
};